import { connect } from 'react-redux'
import { compose, withProps } from 'recompose'
import { getCanonicalUrl } from '../../helpers'
import SchemasHelmet from './SchemasHelmet'


export const mapStateToProps = ({ app: { data }}) => ({
  canonicalUrl: data ? getCanonicalUrl(data) : ''
})

export const withVehicleSchema = withProps(({
  make,
  model,
  year,
  submodel,
  imageSrc,
  canonicalUrl,
  schemasName,
  description
}) => {
  const vehicleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Vehicle',
    name: schemasName,
    description,
    brand: {
      '@type': 'Brand',
      name: make },
    manufacturer: make,
    image: imageSrc,
    url: canonicalUrl
  }

  if (model) {
    vehicleSchema.model = model
  }
  if (year) {
    vehicleSchema.modelDate = year
  }
  if (submodel) {
    vehicleSchema.vehicleConfiguration = submodel
  }

  return {
    vehicleSchema: JSON.stringify(vehicleSchema)
  }
})

export const withProductSchema = withProps(({
  make,
  imageSrc,
  canonicalUrl,
  schemasName,
  description
}) => {
  const productSchema = {
    '@context': 'https://schema.org',
    '@type': 'product',
    name: schemasName,
    image: imageSrc,
    description,
    brand: {
      '@type': 'Thing',
      name: make },
    url: canonicalUrl
  }

  return {
    productSchema: JSON.stringify(productSchema)
  }
})

export const withCarSchema = withProps(({
  make,
  model,
  year,
  submodel,
  imageSrc,
  canonicalUrl,
  schemasName
}) => {
  const carSchema = {
    '@context': 'http://schema.org/',
    '@type': 'Car',
    name: schemasName,
    brand: {
      '@type': 'Brand',
      name: make
    },
    manufacturer: make,
    image: imageSrc,
    url: canonicalUrl
  }

  if (model) {
    carSchema.model = model
  }
  if (year) {
    carSchema.modelDate = year
    carSchema.productionDate = year
  }
  if (submodel) {
    carSchema.vehicleConfiguration = submodel
  }

  return {
    carSchema: JSON.stringify(carSchema)
  }
})

export const withWebPageSchema = withProps(({
  submodel,
  canonicalUrl,
  schemasName,
  speakableIds
}) => {
  const webPageSchema = {
    '@context': 'https://schema.org/',
    '@type': 'WebPage',
    name: schemasName,
    url: canonicalUrl
  }

  // If not a BOTSizeSelector page, adding speakable property value
  if (!submodel) {
    webPageSchema.speakable = {
      cssSelector: speakableIds,
      '@type': 'SpeakableSpecification'
    }
  }

  // TODO According to comments in ticket BOT-2494 we need to update speakable ID's
  // for trim page https://www.bigotires.com/tires/by-vehicle/[make/[model]/[year]/[trim]

  return {
    webPageSchema: JSON.stringify(webPageSchema)
  }
})

export default compose(
  connect(mapStateToProps),
  withVehicleSchema,
  withProductSchema,
  withCarSchema,
  withWebPageSchema
)(SchemasHelmet)
